import { put, call } from 'redux-saga/effects';
import { setCreditCards } from 'app/actions/creditcards';
import { creditcard } from 'mz-sdk';

export default function* fetchCreditCards(action) {
  const creditCards = yield call(creditcard.getCreditCards);
  yield put(setCreditCards(creditCards));
  yield call(action.resolvePromise);
}
